"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = truncate;
function truncate(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength - 1) + '...';
  } else return text;
}